
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, TextField, MenuItem } from '@mui/material';
import { NumberFormatCustom } from '../../../hooks';
import { mediosPago } from '../../../data';
import { BotonesAndCargando } from '../../components/botones';
import { useModalStore } from '../../../stores';
import { crearAbonoGasto } from '../../../services';
import { useQueryClient } from '@tanstack/react-query';


import Swal from 'sweetalert2';





export const FormCrearAbonosGastos = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { modalFormToggle } = useModalStore();
    const [cargando, setCargando] = useState(false)
    
    
    const [ formAbono, setFormAbono ] = useState({ valor: "", medio: "", observacion: "", });
    const { valor, medio, observacion } = formAbono;
    const handleInputChange = ({ target }) => {
        setFormAbono({
            ...formAbono,
            [target.name]: target.value
        });
    }

    

    const handleCrearAbono = async(e) => {
        e.preventDefault();

        if( [medio, valor].includes('') ) {
            return Swal.fire('Error', 'Abono y Medio de Pago Son Campos Obligatorios', 'error');
        }

        setCargando(true);
        const resp = await crearAbonoGasto({...formAbono, id});
        setCargando(false);
        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['gasto-id'] });
            queryClient.invalidateQueries({ queryKey: ['abonoXgastos'] });
            modalFormToggle(false);
        }
    }



    return (

        
        <form onSubmit={ handleCrearAbono } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12}>
                    <TextField required
                        autoComplete='off'
                        label="Valor"
                        fullWidth
                        placeholder='Valor'
                        name="valor"
                        value={ valor }
                        onChange={ handleInputChange }
                        InputProps={{ inputComponent: NumberFormatCustom }}
                        size="small"
                    >
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField required
                        select
                        label="Medio de Pago"
                        fullWidth
                        name="medio"
                        value={ medio }
                        onChange={ handleInputChange }  
                        size="small"
                    >    
                        <MenuItem value=''> Seleccione Medio de Pago</MenuItem>
                        {mediosPago.map( item => (
                            <MenuItem key={item} value={item}> {item}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Observacion"
                        fullWidth
                        placeholder="Observacion"
                        multiline
                        name="observacion"
                        value={ observacion }
                        onChange={ handleInputChange } 
                        size="small"
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Crear Abono'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>

    )
}
